import { Entity } from '@backstage/catalog-model';
import { GITHUB_REPO_ANNOTATION } from '../types';

export const useGithubProjectName = (entity: Entity) => {
  return entity?.metadata.annotations?.[GITHUB_REPO_ANNOTATION] ?? '';
};
